import { GestationalAge } from "@/Patient/Models/ObstetricalFile/GestationalAge";

class BritishColumbiaObstetricalFileDatingEstimates {
    public ContraceptiveType: string;
    public ContraceptiveLastUsedDate: Date;
    public PregnancyPlanned?: boolean;
    public LastMenstrualPeriod: Date;
    public EstimatedDateOfBirthByLastMenstrualPeriod: Date;
    public DatingUltrasound: Date;
    public GestationalAgeByUltrasound: GestationalAge;
    public EstimatedDateOfBirthByUltrasound: Date;

    public constructor(fields?: Partial<BritishColumbiaObstetricalFileDatingEstimates>) {
        Object.assign(this, fields);
        this.GestationalAgeByUltrasound = new GestationalAge(fields?.GestationalAgeByUltrasound);
    }
}

export { BritishColumbiaObstetricalFileDatingEstimates };
